import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MessageSquare } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StorageImage } from "@/components/app/ImageUpload";

export default function CommitteeContacts() {
  const { user } = useAuth();
  const canAsk = user?.role === "admin" || user?.role === "coach";
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/committee-contacts").then(r => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 space-y-6" data-testid="committee-contacts-page">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">The club</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">Committee contacts</h1>
        <p className="opacity-60 text-sm mt-1">Who does what at Elsenham Youth FC and how to reach them.</p>
      </div>
      {!rows ? <div className="opacity-50 font-display tracking-widest">LOADING…</div>
        : rows.length === 0 ? <div className="card-tactical rounded-md p-10 text-center opacity-60" data-testid="committee-contacts-empty">No committee contacts have been added yet.</div>
        : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="committee-contacts-list">
            {rows.map(c => (
              <article key={c.id} className="card-tactical rounded-md p-5 flex flex-col gap-3" data-testid={`committee-contact-${c.id}`}>
                <div className="flex items-center gap-4">
                  {c.photo_path ? <StorageImage path={c.photo_path} alt={c.name} className="w-16 h-16 rounded-full object-cover border border-border flex-shrink-0" />
                    : <div className="w-16 h-16 rounded-full bg-[#83B68B]/20 border border-border flex items-center justify-center font-display font-black text-2xl flex-shrink-0">{c.name?.[0]}</div>}
                  <div className="min-w-0">
                    <h2 className="font-display font-black text-xl leading-tight">{c.name}</h2>
                    <div className="text-[10px] tracking-widest uppercase text-[#83B68B] mt-0.5">{c.position}</div>
                  </div>
                </div>
                {c.responsibilities && <p className="text-sm opacity-80 whitespace-pre-wrap">{c.responsibilities}</p>}
                <div className="mt-auto space-y-1 text-sm">
                  {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-2 hover:text-[#83B68B] break-all" data-testid={`contact-email-${c.id}`}><Mail className="w-3.5 h-3.5 flex-shrink-0" /> {c.email}</a>}
                  {c.phone && <a href={`tel:${c.phone}`} className="flex items-center gap-2 hover:text-[#83B68B]" data-testid={`contact-phone-${c.id}`}><Phone className="w-3.5 h-3.5 flex-shrink-0" /> {c.phone}</a>}
                  {canAsk && <Link to={`/app/committee?to=${c.id}`} data-testid={`contact-ask-${c.id}`} className="mt-2 inline-flex items-center gap-2 px-3 py-2 rounded border border-[#83B68B]/50 text-[#83B68B] text-[10px] tracking-widest uppercase hover:bg-[#83B68B]/10"><MessageSquare className="w-3.5 h-3.5" /> Ask the {c.position}</Link>}
                </div>
              </article>
            ))}
          </div>
        )}
    </div>
  );
}
